import { sql } from "drizzle-orm";
import { check, index, integer, real, sqliteTable, text } from "drizzle-orm/sqlite-core";

// ============================================================================
// purchase_legacy_invoices_archive — retired purchase invoice source table
// ============================================================================
export const purchaseInvoices = sqliteTable("purchase_legacy_invoices_archive", {
  id: text("id").primaryKey(),
  invoiceNo: text("invoice_no").notNull().unique(),
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  invoiceType: text("invoice_type", {
    enum: ["sales", "purchase", "credit_note", "debit_note"],
  }).notNull().default("purchase"),
  partyType: text("party_type", {
    enum: ["customer", "supplier"],
  }).notNull().default("supplier"),
  partyId: text("party_id").notNull(),
  invoiceDate: text("invoice_date").notNull(),
  dueDate: text("due_date"),
  subtotal: real("subtotal").notNull().default(0),
  taxAmount: real("tax_amount").notNull().default(0),
  totalDiscount: real("total_discount").default(0),
  totalWht: real("total_wht").default(0),
  total: real("total").notNull().default(0),
  outstanding: real("outstanding").notNull().default(0),
  docStatus: integer("doc_status").notNull().default(0),
  status: text("status", {
    enum: ["draft", "submitted", "partially_paid", "paid", "overdue", "cancelled"],
  }).notNull().default("draft"),
  creditNoteOf: text("credit_note_of"),
  debitNoteOf: text("debit_note_of"),
  reason: text("reason"),
  originalInvoiceAmount: real("original_invoice_amount"),
  correctedAmount: real("corrected_amount"),
  differenceAmount: real("difference_amount"),
  reasonCode: text("reason_code", {
    enum: [
      "discount",
      "return",
      "price_error",
      "short_delivery",
      "excess_delivery",
      "quality_issue",
      "other",
    ],
  }),
  currencyCode: text("currency_code").default("THB"),
  exchangeRate: real("exchange_rate").default(1),
  transactionType: text("transaction_type"),
  deliveryDate: text("delivery_date"),
  taxPointDate: text("tax_point_date"),
  vatStatus: text("vat_status", {
    enum: ["undue", "due", "reported", "exempt"],
  }).default("due"),
  vatPeriod: text("vat_period"),
  remarks: text("remarks"),
  referenceModule: text("reference_module"),
  referenceDoctype: text("reference_doctype"),
  referenceId: text("reference_id"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyStatusIdx: index("plia_company_status_idx").on(table.companyId, table.status, table.invoiceDate),
  companyPartyIdx: index("plia_company_party_idx").on(table.companyId, table.partyType, table.partyId),
  companyTypeIdx: index("plia_company_type_idx").on(table.companyId, table.invoiceType, table.status),
  companyBranchIdx: index("plia_company_branch_idx").on(table.companyId, table.branchId, table.status),
  creditNoteOfIdx: index("plia_credit_note_of_idx").on(table.creditNoteOf),
  debitNoteOfIdx: index("plia_debit_note_of_idx").on(table.debitNoteOf),
  companyVatPeriodIdx: index("plia_company_vat_period_idx").on(table.companyId, table.vatPeriod, table.vatStatus),
  companyTaxPointIdx: index("plia_company_tax_point_idx").on(table.companyId, table.taxPointDate, table.vatStatus),
  ownerCheck: check("purchase_legacy_invoices_archive_owner_chk", sql`${table.invoiceType} = 'purchase' AND ${table.partyType} = 'supplier'`),
}));

// ============================================================================
// purchase_legacy_debit_notes_archive — retired purchase debit-note source table
// ============================================================================
export const purchaseDebitNotes = sqliteTable("purchase_legacy_debit_notes_archive", {
  id: text("id").primaryKey(),
  invoiceNo: text("invoice_no").notNull().unique(),
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  invoiceType: text("invoice_type", {
    enum: ["sales", "purchase", "credit_note", "debit_note"],
  }).notNull().default("debit_note"),
  partyType: text("party_type", {
    enum: ["customer", "supplier"],
  }).notNull().default("supplier"),
  partyId: text("party_id").notNull(),
  invoiceDate: text("invoice_date").notNull(),
  dueDate: text("due_date"),
  subtotal: real("subtotal").notNull().default(0),
  taxAmount: real("tax_amount").notNull().default(0),
  totalDiscount: real("total_discount").default(0),
  totalWht: real("total_wht").default(0),
  total: real("total").notNull().default(0),
  outstanding: real("outstanding").notNull().default(0),
  docStatus: integer("doc_status").notNull().default(0),
  status: text("status", {
    enum: ["draft", "submitted", "partially_paid", "paid", "overdue", "cancelled"],
  }).notNull().default("draft"),
  creditNoteOf: text("credit_note_of"),
  debitNoteOf: text("debit_note_of"),
  reason: text("reason"),
  originalInvoiceAmount: real("original_invoice_amount"),
  correctedAmount: real("corrected_amount"),
  differenceAmount: real("difference_amount"),
  reasonCode: text("reason_code", {
    enum: [
      "discount",
      "return",
      "price_error",
      "short_delivery",
      "excess_delivery",
      "quality_issue",
      "other",
    ],
  }),
  currencyCode: text("currency_code").default("THB"),
  exchangeRate: real("exchange_rate").default(1),
  transactionType: text("transaction_type"),
  deliveryDate: text("delivery_date"),
  taxPointDate: text("tax_point_date"),
  vatStatus: text("vat_status", {
    enum: ["undue", "due", "reported", "exempt"],
  }).default("due"),
  vatPeriod: text("vat_period"),
  remarks: text("remarks"),
  referenceModule: text("reference_module"),
  referenceDoctype: text("reference_doctype"),
  referenceId: text("reference_id"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyStatusIdx: index("pldna_company_status_idx").on(table.companyId, table.status, table.invoiceDate),
  companyPartyIdx: index("pldna_company_party_idx").on(table.companyId, table.partyType, table.partyId),
  companyTypeIdx: index("pldna_company_type_idx").on(table.companyId, table.invoiceType, table.status),
  companyBranchIdx: index("pldna_company_branch_idx").on(table.companyId, table.branchId, table.status),
  creditNoteOfIdx: index("pldna_credit_note_of_idx").on(table.creditNoteOf),
  debitNoteOfIdx: index("pldna_debit_note_of_idx").on(table.debitNoteOf),
  companyVatPeriodIdx: index("pldna_company_vat_period_idx").on(table.companyId, table.vatPeriod, table.vatStatus),
  companyTaxPointIdx: index("pldna_company_tax_point_idx").on(table.companyId, table.taxPointDate, table.vatStatus),
  ownerCheck: check("purchase_legacy_debit_notes_archive_owner_chk", sql`${table.invoiceType} = 'debit_note' AND ${table.partyType} = 'supplier'`),
}));

export type PurchaseInvoice = typeof purchaseInvoices.$inferSelect;
export type NewPurchaseInvoice = typeof purchaseInvoices.$inferInsert;
export type PurchaseDebitNote = typeof purchaseDebitNotes.$inferSelect;
export type NewPurchaseDebitNote = typeof purchaseDebitNotes.$inferInsert;
